import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Livello_2"
    width={48}
    height={48}
    data-name="Livello 2"
    {...props}
  >
    <defs>
      <style>{".cls-16{fill:none;stroke:#a3d8e7;stroke-miterlimit:10}"}</style>
    </defs>
    <g id="Palette">
      <path
        d="m39.51 2.83 5.66 5.66L10.56 43.1l-7.73 2.07 2.07-7.73L39.51 2.83m0-2.83L3.11 36.41 0 48l11.59-3.11L48 8.49 39.51 0Z"
        style={{
          fill: "#a3d8e7",
          strokeWidth: 0,
        }}
      />
      <path d="m34.9 6.74 6.36 6.36M4.17 37.47l6.36 6.36" className="cls-16" />
    </g>
  </svg>
)
export default SvgComponent
